import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Organizationprofile from "../Organizationprofile";

function AdminOrganizationProfile(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={6}
        childrenPage={<Organizationprofile/>}/>
        </DataContext.Provider>
    )
}

export default AdminOrganizationProfile;